import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { EncryptedCell } from '@/components';
import Field from '../../../../../field';
import getFormattedCountryLabels from '../utils/get-formatted-country-labels';
export type CitizenshipsType = {
  di: DataIdentifier;
  entity: Entity;
};
const Citizenships = t0 => {
  const $ = _c(3);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($[0] !== di || $[1] !== entity) {
    t1 = <Field di={di} entity={entity} renderValue={_temp} />;
    $[0] = di;
    $[1] = entity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Citizenships;
function _temp(value) {
  if (value && isVaultDataDecrypted(value)) {
    const citizenships = getFormattedCountryLabels(value);
    return <div className="text-body-2 text-primary" data-dd-privacy="mask">{citizenships}</div>;
  }
  return <EncryptedCell />;
}